const { DateOfBirthPrototype } = require("./prototypes");

function DateOfBirthType() {
  this.type = "dateofbirth";

  this.calculateAge = ({ year, month = 1, day = 1 }) => {
    const birthDay = new Date(year, Number(month - 1), Number(day), 0, 0, 0);
    const now = new Date();
    return new Date(now - birthDay).getUTCFullYear() - 1970;
  };

  this.validate = ({ eligibility, answer }) => {
    try {
      const [year, month, day] = answer.split("-");
      const yyyymmdd = { year, month, day };
      const age = this.calculateAge(yyyymmdd);
      const { type, min, max, value } = eligibility;

      if (!age) return false;

      switch (type) {
        case "older":
          return age >= value;
        case "between":
          return age >= min && age <= max;
        case "younger":
          return age <= value;
        default:
          return false;
      }
    } catch {
      return false;
    }
  };
}

DateOfBirthType.prototype = DateOfBirthPrototype;

module.exports = DateOfBirthType;
